export class GearboxContext {
    name: string;
    description: string;
    ruleId: string;
    selectedIds: string[];
    createInstance: boolean;
    createTemplate: boolean;
}
